import { optionify } from 'lib/helpers/utility';
import { useStates } from 'lib/hooks/queries/states/useStates';

import Input from 'components/shared/Input/Input';
import Button from 'components/shared/Button/Button';
import Select from 'components/shared/Select/Select';

import { useElavonTokenize } from '../lib/useElavonTokenize';
import { useFormikFieldChange } from '../lib/useFormikFieldChange';

const ElavonCardForm = ({
  patientId,
  onTokenized,
  hideButton = false,
  showCardholderName = true
}) => {
  const { formik, setField, handleFieldChange } = useFormikFieldChange();
  const { tokenize, isTokenizing } = useElavonTokenize({ formik, patientId, onTokenized });

  const { data: statesData } = useStates();
  const states = optionify(statesData?.states, 'name', 'id');

  return (
    <div className="flex w-full flex-col gap-5">
      <div className="grid grid-cols-2 gap-x-3 gap-y-2 sm:grid-cols-1">
        {showCardholderName && (
          <Input
            label="Cardholder name"
            name="cardholderName"
            placeholder="Enter cardholder name"
            value={formik.values.cardholderName}
            onChange={handleFieldChange}
            error={formik.touched.cardholderName && formik.errors.cardholderName}
            errorClassName="text-xs"
            required
          />
        )}
        <Input
          label="Address 1"
          name="address_ln_1"
          value={formik.values.address_ln_1}
          onChange={handleFieldChange}
          error={formik.errors.address_ln_1}
          errorClassName="text-xs"
          isOptional
        />
        <Input
          label="Address 2"
          name="address_ln_2"
          value={formik.values.address_ln_2}
          onChange={handleFieldChange}
          error={formik.errors.address_ln_2}
          errorClassName="text-xs"
          isOptional
        />
        <Input
          label="City"
          name="city"
          value={formik.values.city}
          onChange={handleFieldChange}
          error={formik.errors.city}
          errorClassName="text-xs"
          isOptional
        />
        <Select
          label="State"
          name="state"
          placeholder="Select state"
          value={states?.find((state) => state.value === formik.values.state)}
          onChange={(option) => setField('state', option?.value)}
          options={states}
          error={formik.errors.state}
          errorClassName="text-xs"
          isOptional
        />
        <Input
          label="Zip code"
          name="zip"
          placeholder="Zip code"
          value={formik.values.zip}
          onChange={handleFieldChange}
          error={formik.errors.zip}
          errorClassName="text-xs"
          isOptional
        />
      </div>
      {!hideButton && (
        <Button
          text="Proceed with card details"
          iconRight="arrow-right-linear"
          size="small"
          className="w-fit"
          onClick={tokenize}
          isLoading={isTokenizing}
        />
      )}
    </div>
  );
};

export default ElavonCardForm;
